const Waitlist = () => {
    return (
        <div className="min-h-screen pt-32 flex flex-col items-center p-6">
            <h1 className="text-4xl font-bold text-center mb-4">Get Early Access</h1>
            <p className="text-xl mb-12 text-center max-w-2xl">
                Be among the first to experience AI-powered message suggestions. You'll receive instructions instantly.
            </p>
            <iframe
                title="Waitlist Form"
                width="540"
                height="1200"
                src="https://fbb7b9d4.sibforms.com/serve/MUIFABNyQn6cCXPH8QcYMaaDJtEMXhOmBYe8YEjrzTIr6TOK2P1HGToeZIWsqZy9z1K2MO4EAE94oL2SaIuH8XziAM08tFMQ3z18lLKX90RbugmhN7Ig6s5D41SxbMK3-SKK6uGa4laHIMNgUfufW4Gf7HP2cFJCRc0T85wCIkk81yKXGjnbfK1MJQdBGsFI4IqJp-wZy84M-bdu"
                frameborder="0"
                scrolling="auto"
                allowfullscreen
                style={{ display: "block", marginLeft: "auto", marginRight: "auto", maxWidth: "100%" }}
            ></iframe>
        </div>
    );
};

export default Waitlist;
